/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M14.0001 16H3.00012M10.0001 16L3.50012 7.5M20.5001 16.5L14.0001 8M10.0001 21.5L17.0001 12M7.00012 12L14.0001 2.5M21.0001 8H10.0001"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<circle
				cx="12"
				cy="12"
				r="10"
				stroke="currentColor"
				strokeWidth="1.5"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12.0001 22C17.523 22 22.0001 17.5228 22.0001 12C22.0001 6.47715 17.523 2 12.0001 2C6.47727 2 2.00012 6.47715 2.00012 12C2.00012 17.5228 6.47727 22 12.0001 22ZM9.70012 8.4L7.45012 11.4C7.18346 11.7556 7.18346 12.2444 7.45012 12.6L9.70012 15.6C9.88898 15.8518 10.1854 16 10.5001 16H13.5001C13.8149 16 14.1113 15.8518 14.3001 15.6L16.5501 12.6C16.8168 12.2444 16.8168 11.7556 16.5501 11.4L14.3001 8.4C14.1113 8.14819 13.8149 8 13.5001 8L10.5001 8C10.1854 8 9.88898 8.14819 9.70012 8.4Z"
				fill="currentColor"
			/>
			<path
				d="M14.0001 16H3.00012M10.0001 16L3.50012 7.5M20.5001 16.5L14.0001 8M10.0001 21.5L17.0001 12M7.00012 12L14.0001 2.5M21.0001 8H10.0001M22.0001 12C22.0001 17.5228 17.523 22 12.0001 22C6.47727 22 2.00012 17.5228 2.00012 12C2.00012 6.47715 6.47727 2 12.0001 2C17.523 2 22.0001 6.47715 22.0001 12Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M2.75 12C2.75 10.7988 2.97895 9.65112 3.3956 8.59815L8.48231 15.25L3.33707 15.25C2.95756 14.2389 2.75 13.1437 2.75 12ZM6.96 10.79L4.14638 7.1106C5.77994 4.49223 8.68651 2.75 12 2.75C12.2884 2.75 12.5737 2.7632 12.8554 2.78903L6.96 10.79ZM11.4316 7.25L14.4963 3.09076C16.7979 3.73431 18.7371 5.24576 19.9389 7.25L11.4316 7.25ZM15.5177 8.75L20.6629 8.75C21.0424 9.76111 21.25 10.8563 21.25 12C21.25 13.2012 21.021 14.3489 20.6044 15.4019L15.5177 8.75ZM17.04 13.2101L19.8536 16.8894C18.2201 19.5078 15.3135 21.25 12 21.25C11.7116 21.25 11.4263 21.2368 11.1446 21.211L17.04 13.2101ZM12.5684 16.75L9.50369 20.9092C7.2021 20.2657 5.26287 18.7542 4.06111 16.75L12.5684 16.75ZM12 1.25C6.06294 1.25 1.25 6.06294 1.25 12C1.25 17.9371 6.06294 22.75 12 22.75C17.9371 22.75 22.75 17.9371 22.75 12C22.75 6.06294 17.9371 1.25 12 1.25Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M19.1416 5C17.3266 3.14864 14.7975 2 12.0001 2C6.47727 2 2.00012 6.47715 2.00012 12C2.00012 17.5228 6.47727 22 12.0001 22C17.523 22 22.0001 17.5228 22.0001 12C22.0001 11.3151 21.9313 10.6462 21.8001 10M14.0001 16H3.00012M10.0001 16L3.50012 7.5M20.5001 16.5L14.0001 8M10.5001 21.5L17.0001 12M7.00012 12L14.0001 2.5M17.5001 8H10.0001"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M14 16H3M10 16L3.5 7.5M20.5 16.5L14 8M10 21.5L17 12M7 12L14 2.5M21 8H10M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M7 12L10 8H14L17 12L14 16H10L7 12Z"
				fill="currentColor"
			/>
			<path
				d="M14 16H3M10 16L3.5 7.5M20.5 16.5L14 8M10 21.5L17 12M7 12L14 2.5M21 8H10M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
				stroke="currentColor"
				strokeWidth="1.5"
			/>
		</Fragment>,
	],
]);
